import { BaseModalComponent } from './../base/base-modal.component';
import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'inc-annotation-modal',
  templateUrl: './annotation-modal.component.html'
})
export class AnnotationModalComponent extends BaseModalComponent {
  title = 'ANNOTATION';

  constructor(modalController: ModalController) {
    super(modalController);
    this.reset(new FormGroup({
      author: new FormGroup({
        authorReference: new FormGroup({
          reference: new FormControl('')
        }),
        authorString: new FormControl('')
      }),
      time: new FormControl(new Date().toISOString()),
      text: new FormControl(null, Validators.required)
    }));
  }

  save() {
    this.baseSave({ value: { note: this.form } });
  }

}
